import { datadogLogs } from "@datadog/browser-logs";

const XHR_ERROR_PATTERN = /xhr error/i;
const FETCH_ERROR_POST_PATTERN = /fetch error post/i;

export const datadogInit = async function () {
  if (process.env.NEXT_PUBLIC_DATADOG) {
    datadogLogs.init({
      clientToken: process.env.NEXT_PUBLIC_DATADOG,
      site: "datadoghq.com",
      forwardErrorsToLogs: true,
      sessionSampleRate: 100,
      service: "marketing-monorepo",
      env: process.env.NEXT_PUBLIC_ENVIRONMENT,
      version: process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA,
      beforeSend: (log) => {
        if (
          XHR_ERROR_PATTERN.test(log.message) ||
          FETCH_ERROR_POST_PATTERN.test(log.message)
        ) {
          return false;
        }
        return true;
      },
    });
  }
};
